/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_user = {
    readonly canShowSellerName: boolean | null;
    readonly canShowInternalSellerName: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_user" | "SbRespSearchResultContainer_user" | "SbSharedRelatedItems_user" | "SbRespRefineTopNav_user">;
    readonly " $refType": "SbRespMainContent_user";
};
export type SbRespMainContent_user$data = SbRespMainContent_user;
export type SbRespMainContent_user$key = {
    readonly " $data"?: SbRespMainContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "canShowInternalSellerName",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "VIEW_SELLER_NAME"
        }
      ],
      "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_user",
      "args": null
    }
  ]
};
(node as any).hash = 'd572b1e53ccb605e4476451f6480c4f8';
export default node;
